import { Injectable } from "@angular/core";
import { QualityControlMonthlyLineContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-monthly-line-container.model";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class QualityControlMonthlyLineService extends BaseApiTemplateService<QualityControlMonthlyLineContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/monthly-lines";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/monthly-lines";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/monthly-lines";
		this.httpClient = http;
	}
}
